import { render } from "./ManageRiskRegisterModal.vue?vue&type=template&id=f6031354&scoped=true"
import script from "./ManageRiskRegisterModal.js?vue&type=script&lang=js"
export * from "./ManageRiskRegisterModal.js?vue&type=script&lang=js"

import "./ManageRiskRegisterModal.vue?vue&type=style&index=0&id=f6031354&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6031354"]])

export default __exports__